import React, { useEffect } from "react";
import FormInputs from "../../../components/UI/FormInputs";

const RangeOfMotion = (props) => {
  const { field, setFormState, formState, normalSelectedId, checked ,setNormalSelectedId,setChecked,setIsFormDirty} = props;
  // console.log("normalSelectedId", normalSelectedId, " checked", checked);

  useEffect(() => {
    // Only act if this field is the selected one
    if (field.id !== normalSelectedId) return;

    const updatedField = { ...(formState?.[field.id] || {}) };

    field.options.forEach((option) => {
      if (checked) {
        // SET to normal (max_value)
        if (field.range_direction === "left_right_rom") {
          updatedField[option.id] = {
            left: option.max_value,
            right: option.max_value,
          };
        } else {
          updatedField[option.id] = option.max_value;
        }
      } else {
        // CLEAR values
        if (field.range_direction === "left_right_rom") {
          updatedField[option.id] = {
            left: "",
            right: "",
          };
        } else {
          updatedField[option.id] = "";
        }
      }
    });

    setFormState((prev) => ({
      ...prev,
      [field.id]: updatedField,
    }));
  }, [
    normalSelectedId,
    checked,
    field.id,
    field.options,
    field.range_direction,
  ]);

  let value = formState?.[field.id];

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === "object") {
        value = parsed;
      }
    } catch (e) {}
  }

  const handleOptionChange = (optionId, sideOrSingle, val) => {
    if (setIsFormDirty) {
      setIsFormDirty(true);
    }
    if (normalSelectedId === field.id) {
      setNormalSelectedId("");
      setChecked(false);       
    }
    setFormState({
      ...formState,
      [field.id]: {
        ...(value || {}),
        [optionId]: {
          ...(value?.[optionId] || {}),
          [sideOrSingle]: val,
        },
      },
    });
  };

  const getValidationClass = (val, min, max) => {
    const num = Number(val);
    return num !== "" && (num < min || num > max)
      ? "cal_text-red font-weight-bold"
      : "";
  };

  return (
    <div className="card w-100 mb-0 pb-2 shadow-none border-0">
      {!props.isExam && (
        <div className="card-header sh_subaccordionheader d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
          <h6 className="text-sm mb-0">
            {field.label}
            {/* {field.is_required && <span className="text-danger">*</span>} */}{" "}
          </h6>
          <span
              className={`sh_emr_roundbadge ml-1  ${
                normalSelectedId === field.id && checked ? "normal" : "chart"
              }`}
              title="All Normal"
              onClick={() => {
                setIsFormDirty(true);
                setNormalSelectedId(field.id);
                if (normalSelectedId == field.id) {
                  setChecked((prev) => !prev); // toggle checked state
                } else {
                  setChecked(true); // always set to true when selecting a new field
                }
              }}
            >
              N
            </span>
          </div>

          
        </div>
      )}

      <div className="card-body py-0">
        <div className="row">
          {field.range_direction === "left_right_rom" ? (
            <div className="col-12 px-0">
              <table
                className="table sh_tablenew my-2"
                width="100%"
                cellSpacing="0"
              >
                <thead>
                  <tr className="">
                    <th className="sh_emrmotiontd">Motion</th>
                    <th
                      className="text-center "
                      style={{ verticalAlign: "middle" }}
                    >
                      Left&nbsp; (°)
                    </th>
                    <th
                      className="text-center "
                      style={{ verticalAlign: "middle" }}
                    >
                      Right (°)
                    </th>
                    <th className="sh_emrmotiontd">Normal Range (°)</th>
                  </tr>
                </thead>
                <tbody>
                  {field.options.map((option, index) => (
                    <tr key={option.id || index}>
                      <td className="sh_emrmotiontd">{option.value}</td>
                      <td className="text-center">
                        <FormInputs
                          type="Number"
                          className={`form-control text-center ${getValidationClass(
                            value?.[option.id]?.left,
                            option.min_value,
                            option.max_value
                          )}`}
                          name={`left_${index}`}
                          value={value?.[option.id]?.left || ""}
                          changeHandler={(val) =>
                            handleOptionChange(option.id, "left", val)
                          }
                        />
                      </td>
                      <td className="text-center ">
                        <FormInputs
                          type="Number"
                          className={`form-control text-center ${getValidationClass(
                            value?.[option.id]?.right,
                            option.min_value,
                            option.max_value
                          )}`}
                          name={`right_${index}`}
                          value={value?.[option.id]?.right || ""}
                          changeHandler={(val) =>
                            handleOptionChange(option.id, "right", val)
                          }
                        />
                      </td>
                      <td className="sh_emrmotiontd">
                        <strong>
                          {option.min_value} - {option.max_value} degree
                        </strong>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="col-12 px-0">
              <table
                className="table sh_tablenew my-2"
                width="100%"
                cellSpacing="0"
              >
                <thead>
                  <tr className="">
                    <th className="sh_emrmotiontd">Motion</th>
                    <th
                      className="text-center "
                      style={{ verticalAlign: "middle" }}
                    >
                      Value (°)
                    </th>
                    <th className="sh_emrmotiontd">Normal Range (°)</th>
                  </tr>
                </thead>
                <tbody>
                  {field.options.map((option, index) => (
                    <tr key={option.id || index}>
                      <td className="sh_emrmotiontd">{option.value}</td>
                      <td className="text-center ">
                        <FormInputs
                          type="Number"
                          className={`form-control text-center ${getValidationClass(
                            value?.[option.id],
                            option.min_value,
                            option.max_value
                          )}`}
                          name={`value_${index}`}
                          value={value?.[option.id] || ""}
                          changeHandler={(val) => {
                            setIsFormDirty(true);
                            if (normalSelectedId === field.id) {
                            setNormalSelectedId("");
                            setChecked(false);
                            }
                            setFormState((prevState) => ({
                              ...prevState,
                              [field.id]: {
                                ...(prevState[field.id] || {}),
                                [option.id]: val,
                              },
                            }));
                          }}                          
                        />
                      </td>
                      <td className="sh_emrmotiontd">
                        <strong>
                          {option.min_value} - {option.max_value} degree
                        </strong>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RangeOfMotion;
